export abstract class Constants {
  static readonly YES = "Yes";
  static readonly NO = "No";

  static readonly COMMON_Recipe = "Recipe";
  static readonly COMMON_Customer = "Customer";
  static readonly COMMON_Dataset = "Dataset";
  static readonly COMMON_Dashboard = "Dashboard";
  static readonly COMMON_Product = "Product";
  static readonly COMMON_Lob = "Lob";
  static readonly COMMON_LOB = "LOB";
  static readonly COMMON_Dataset_Name = "Dataset Name";
  static readonly COMMON_Attribute = "Attribute";

  static readonly TRANSFORM_DATE_Date_Field_Attributes = "Date Field Attributes";
  static readonly TRANSFORM_DATE_Select_Date_Field = "Select Date Field";
  static readonly TRANSFORM_DATE_Target_Output_Date_Format = "Target/Output Date Format";
  static readonly TRANSFORM_DATE_Add_Attribute = "Add Attribute";

  static readonly TRANSFORM_Current_Dataset = "Current Dataset";
  static readonly TRANSFORM_Default_Target_Output_Format = "Default Target/Output Format";
  static readonly TRANSFORM_Default_Target_Date_Format_Value = "yyyy-MM-dd";
  static readonly TRANSFORM_At_Least_One_Date_Field_Required = "At least one date field should be added.";

  static readonly LEFT_MENU_Configuration = "Configuration";
  static readonly LEFT_MENU_Logs = "Logs";
  static readonly LEFT_MENU_Results = "Results";
  static readonly LEFT_MENU_Reports = "Reports";
  static readonly LEFT_MENU_Storage = "Storage";
  static readonly LEFT_MENU_Raw_Upload = "Upload to Raw";
  static readonly LEFT_MENU_Harmonized_Explorer = "Harmonized Explorer";
  static readonly LEFT_MENU_Kpi = "KPI";
  static readonly LEFT_MENU_S3_Statistics = "S3 Statistics";
  static readonly LEFT_MENU_Customer_Metrics = "Customer Metrics";

  static readonly CUSTOMER_ITEM_Customer_Name = "Customer Name";
  static readonly CUSTOMER_ITEM_Customer_ISO = "Customer ISO Company Code";
  static readonly CUSTOMER_ITEM_Email = "Email";
  static readonly CUSTOMER_ITEM_Phone = "Phone";
  static readonly CUSTOMER_ITEM_Address = "Address";
  static readonly CUSTOMER_ITEM_Scopes = "Scopes";

  static readonly CUSTOMER_SCOPE_Source_System = "Source System Name";

  static readonly DATASET_ITEM_Customer_Name = "Customer Name";
  static readonly DATASET_ITEM_Source_System = "Source System";
  static readonly DATASET_ITEM_Dataset_Description = "Dataset Description";
  static readonly DATASET_ITEM_File_Delimiter = "File Delimiter";
  static readonly DATASET_ITEM_File_Type = "File Type";
  static readonly DATASET_ITEM_Filename_Pattern = "Filename Pattern";
  static readonly DATASET_ITEM_Number_Files = "Number of Files";
  static readonly DATASET_ITEM_Dataset_Attributes = "Dataset Attributes";
  static readonly DATASET_ITEM_Json_Configuration = "Json Configuration";
  static readonly DATASET_ITEM_Json_Configuration_Original_Property = "Property Path (Comma Seperated)";
  static readonly DATASET_ITEM_Json_Configuration_New_Name = "New Column";
  static readonly DATASET_ITEM_Json_Configuration_Action = "Action";
  static readonly DATASET_ITEM_Json_Configuration_Property = "Original Property";
  static readonly DATASET_ITEM_Json_Configuration_Column_Name = "Column Name";
  static readonly DATASET_ITEM_Json_Configuration_Column_Value = "Column Value";
  static readonly DATASET_ITEM_Json_Configuration_Attach_To = "Attach To";
  static readonly DATASET_ITEM_Handshake_Settings = "Handshake Configuration";
  static readonly DATASET_ITEM_Error_Report_Output = "Error Report Output";
  static readonly HANDSHAKE_QualityChecks_Output = "Quality Check Output";
  static readonly HANDSHAKE_NameTemplate = "Name Template";
  static readonly HANDSHAKE_Pattern = "Pattern";
  static readonly HANDSHAKE_GroupTemplate = "Handshake Group Template";
  static readonly HANDSHAKE_QualityChecks_Config = "Quality Checks";
  static readonly HANDSHAKE_ValidationProperty = "Validation Name";
  static readonly HANDSHAKE_Origin_Property = "Origin Property";
  static readonly HANDSHAKE_Origin_Operation = "Origin Operation";
  static readonly HANDSHAKE_Data_Property = "Data Property";
  static readonly HANDSHAKE_Data_Operation = "Data Operation";
  static readonly HANDSHAKE_As_Not_Numeric = "As Not Numeric";
  static readonly HANDSHAKE_Action = "Action";


  static readonly TARGET_DATASET_Description = "Description";
  static readonly TARGET_DATASET_Attributes = "Attributes";

  static readonly RECIPE_MAP_TargetColumn = "Target Column";
  static readonly RECIPE_MAP_SourceColumn = "Source Column";
  static readonly RECIPE_MAP_Notes = "Notes";

  static readonly COMMENT_Comments = "Comments";
  static readonly COMMENT_New_Comment = "New Comment";
  static readonly COMMENT_Save = "Save Comment";
  static readonly COMMENT_Clear = "Clear";

  static readonly STEP_LIST_Recipe = "Recipe";
  static readonly STEP_LIST_Edit = "Edit";
  static readonly STEP_LIST_Delete = "Delete";

  static readonly RECIPE_IDENTIFICATION_Source_System = "Source System";

  static readonly Kpi_Report = "Report";
  static readonly Kpi_Year = "Year";
  static readonly Kpi_Quarter = "Quarter";
  static readonly Kpi_Quarterly_Report = "Quarterly Report";
  static readonly Kpi_Recipe_Report = "Recipe Statistics";
  static readonly Kpi_S3_Report = "S3 Statistics";
  static readonly Folder_Pattern_Search_Report = "Files search in S3";

  static readonly Email_Address = "Email Address";
  static readonly Customer_Email_Notification = "Customer Email Notifications";
}

